import React, { useState, useRef, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import Input from "@material-ui/core/Input";
import Button2 from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from '@material-ui/core/styles';
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { v4 as uuid } from "uuid";
import Preview from "../components/Preview.js";
import ReactSelect from "../../UI/ReactSelect";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import PlusIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import InputMask from "react-input-mask";


const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
  },

  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  iconSmall: {
    fontSize: 20,
  },
}));

const initialValues = {
  name: "",
  contactPersonFirstName: "",
  contactPersonLastName: "",
  phoneNumber: "",
  email: "",
  cityId: "",
  filePath: "",
};

export default function Create(props) {
  const classes = useStyles();
  const {
    show,
    onHide,
    onPartners,
    skip,
    take,
    sortField,
    orderBy,
    cities,
  } = props;
  const [imageSrc, setImageSrc] = useState("");
  const [preview, setPreview] = useState(false);
  const [isError, setIsError] = useState("");
  const [file, setFile] = useState("");


  const _defaultCosts = [
    {
      cityId: "",
      address: "",
      latitude: "",
      longitude: "",
    }
  ];


  const [costs, setCosts] = useState(_defaultCosts);

  const form = useRef(null);

  const [phoneNumber, setPhoneNumber] = React.useState("");
  // function handleChangePhoneNumber(e) {
  //   setPhoneNumber(e.target.value);
  // }



  const CreateSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    contactPersonFirstName: Yup.string().required(
      "Contact person firstname is required"
    ),
    contactPersonLastName: Yup.string().required(
      "Contact person lastname is required"
    ),
    phoneNumber: Yup.string().required("Phone number is required"),
    email: Yup.string().required("Email is required")
      .email("Wrong email format. E.g. jhon.doe@example.com")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
    ,
    cityId: Yup.string().required("Cities is required"),
    // address: Yup.string().required("Address is required"),
    // latitude: Yup.string().required("Latitude is required"),
    // longitude: Yup.string().required("Longitude is required"),
  });



  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const [citiesOption, setCitiesOption] = React.useState([{}]);
  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostPartner(values, resetForm, setSubmitting);
    },
  });
  // function handleChangeCities(value) {
  //   setCitiesOption(value);
  //   const cities = value.map((v) => v.value);
  //   formik.setFieldValue("cityId", cities);
  // }

  function handleChangeCities(value, name, index) {
    let newCities = [...citiesOption];
    newCities[index] = value
    setCitiesOption(newCities);
    formik.setFieldValue(name, value.value)
  }
  const imagePreview = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    setFile(e.target.value);

    reader.onloadend = () => {
      setImageSrc(reader.result);
    };

    reader.readAsDataURL(file);

    setPreview(true);
  };
  const onClick = (e) => {
    setPreview(false);
    setImageSrc("");
    setFile("");
  };

  const onPostPartner = (values, resetForm, setSubmitting) => {
    const partner = new FormData(form.current);

    costs.forEach((value, index) => {
      if (value.cityId) {
        partner.append(`Cities[${index}].CityId`, value.cityId);
      }
      if (value.address.trim()) {
        partner.append(`Cities[${index}].Address`, value.address);
      }
      if (value.latitude.trim()) {
        partner.append(`Cities[${index}].Latitude`, value.latitude);
      }
      if (value.longitude.trim()) {
        partner.append(`Cities[${index}].Longitude`, value.longitude);
      }
    })

    axios
      .post(`${process.env.REACT_APP_API_URL}partner`, partner, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then((res) => {
        onPartners(skip, take, sortField, orderBy);
        setSubmitting(false);
        setPreview(false);
        setImageSrc("");
        setFile("");
        resetForm();
        onHide();
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const citiesOptions = cities.map((suggestion) => ({
    value: suggestion.id,
    label: suggestion.name,
  }));



  const handleCostsChange = (event) => {
    const _tempCosts = [...costs];

    _tempCosts[event.target.dataset.id][event.target.name] = event.target.value;

    setCosts(_tempCosts);
  };
  const handleCostsChangeName = (fieldName, index, value) => {
    const _tempCosts = [...costs];

    _tempCosts[index][fieldName] = value;

    setCosts(_tempCosts);
  };

  const addNewCost = () => {
    setCosts((prevCosts) => [...prevCosts, { cityId: "", address: "", latitude: "", longitude: "", }]);
  };

  const removeCost = (index) => {
    const _tempCosts = [...costs];
    const newCosts = _tempCosts.filter((v, i) => i !== index)

    const cities = [...citiesOption]
    const newCities = cities.filter((v, i) => i !== index);
    setCitiesOption(newCities)
    setCosts(newCosts)

  }

  useEffect(() => {
    setIsError("");
    setPhoneNumber("");

    if (!show) {
      setCitiesOption([]);
      setCosts([])
    }
  }, [show]);




  return (
    <Modal
      size="md"
      aria-labelledby="edit"
      centered
      className="modal-right pr-0"
      show={show}
      onHide={onHide}
    >

      <form onSubmit={formik.handleSubmit} ref={form}>
        <Modal.Header closeButton>
          <Modal.Title id="edit">Create</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="name"
                    name="name"
                    label="Name"
                    placeholder="Name"
                    className="w-100"
                    error={getInputClasses("name")}
                    {...formik.getFieldProps("name")}
                  />
                </div>
                {formik.touched.name && formik.errors.name ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.name}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="contactPersonFirstName"
                    name="contactPersonFirstName"
                    label="Contact person firstname"
                    placeholder="Contact person firstname"
                    className="w-100"
                    error={getInputClasses("contactPersonFirstName")}
                    {...formik.getFieldProps("contactPersonFirstName")}
                  />
                </div>
                {formik.touched.contactPersonFirstName &&
                  formik.errors.contactPersonFirstName ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.contactPersonFirstName}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="contactPersonLastName"
                    name="contactPersonLastName"
                    label="Contact person last name"
                    placeholder="Contact person last name"
                    className="w-100"
                    error={getInputClasses("contactPersonLastName")}
                    {...formik.getFieldProps("contactPersonLastName")}
                  />
                </div>
                {formik.touched.contactPersonLastName &&
                  formik.errors.contactPersonLastName ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.contactPersonLastName}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  {/* <TextField
                    id="phoneNumber"
                    name="phoneNumber"
                    label="Phone number"
                    placeholder="Phone number"
                    className="w-100"
                    error={getInputClasses("phoneNumber")}
                    {...formik.getFieldProps("phoneNumber")}
                  /> */}
                  <InputMask
                    mask="\9\94999999999"
                    {...formik.getFieldProps("phoneNumber")}
                    disabled={false}
                    maskChar=""
                    id="phoneNumber"
                    type="number"
                  >
                    {() =>
                      <TextField
                        label="Phone Number"
                        placeholder="Phone Number"
                        className="w-100"
                        name="phoneNumber"
                      // error={getInputClasses("cityPhoneNumber")}
                      />}
                  </InputMask>
                </div>
                {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.phoneNumber}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="d-none">{phoneNumber}</div>

              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="email"
                    name="email"
                    label="Email"
                    placeholder="Email"
                    className="w-100"
                    error={getInputClasses("email")}
                    {...formik.getFieldProps("email")}
                  />
                </div>
                {formik.touched.email && formik.errors.email ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.email}</div>
                  </div>
                ) : null}
              </div>


              {costs.map((item, index) => (
                <div className="col-12 col-md-12 col-lg-12" key={index}>
                  <div>
                    {index ? <div className="d-flex justify-content-end">
                      <Button variant="light" className={classes.button} onClick={() => removeCost(index)}>
                        <DeleteIcon />
                      </Button>
                    </div> : ""}

                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <input type="text" hidden name={`${index === 0 ? "cityId" : `cityId[${index}]`}`} data-id={index}   {...formik.getFieldProps(`${index === 0 ? "cityId" : `cityId[${index}]`}`)} />
                      <ReactSelect
                        suggestions={citiesOptions}
                        handleChangeSingle={(value) => {
                          handleChangeCities(value, `${index === 0 ? "cityId" : `cityId[${index}]`}`, index)
                          handleCostsChangeName("cityId", index, value.value)
                        }}
                        single={citiesOption[index]}
                        label="Choose cities"
                        placeholder="Choose cities"

                      // error={getInputClasses(`${index === 0 ? "cityId" : `cityId[${index}]`}`)}
                      // {...formik.getFieldProps(`${index === 0 ? "cityId" : `cityId[${index}]`}`)}
                      />
                    </div>
                    {formik.touched.cityId && formik.errors.cityId && index === 0 ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">{formik.errors.cityId}</div>
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <TextField
                        id="address"
                        name="address"
                        label="Address"
                        placeholder="Address"
                        className="w-100"
                        value={item.address}
                        // error={getInputClasses("address")}
                        // {...formik.getFieldProps("address")}
                        onChange={handleCostsChange}
                        inputProps={{
                          "data-id": index
                        }}
                      />
                    </div>
                    {formik.touched.address && formik.errors.address && index === 0 ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">{formik.errors.address}</div>
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <TextField
                        id="latitude"
                        name="latitude"
                        label="Latitude"
                        placeholder="Latitude"
                        className="w-100"
                        inputProps={{
                          "data-id": index
                        }}
                        value={item.latitude}
                        // error={getInputClasses("latitude")}
                        // {...formik.getFieldProps("latitude")}
                        onChange={handleCostsChange}
                      />
                    </div>
                    {formik.touched.latitude && formik.errors.latitude && index === 0 ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">{formik.errors.latitude}</div>
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                      <TextField
                        id="longitude"
                        name="longitude"
                        label="Longitude"
                        placeholder="Longitude"
                        className="w-100"
                        inputProps={{
                          "data-id": index
                        }}
                        value={item.longitude}
                        // error={getInputClasses("longitude")}
                        // {...formik.getFieldProps("longitude")}
                        onChange={handleCostsChange}
                      />
                    </div>
                    {formik.touched.longitude && formik.errors.longitude && index === 0 ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">{formik.errors.longitude}</div>
                      </div>
                    ) : null}
                  </div>

                </div>

              ))}

              {/* <button type="button" onClick={addNewCost}>+</button> */}
              <Button variant="light" className={classes.button} onClick={addNewCost}>
                Add city
                <PlusIcon className={classes.rightIcon} />
              </Button>

              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3">
                  <label htmlFor="contained-button-file">
                    <Input
                      accept="image/*"
                      id="contained-button-file"
                      type="file"
                      name="file"
                      label="File {Path}"
                      placeholder="File Path"
                      className="w-100"
                      onChange={imagePreview}
                      value={file}
                      hidden
                    />
                    <Button2 variant="contained" component="span">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Devices/Camera.svg"
                        )}
                        className="mr-2"
                      />
                      Upload image
                    </Button2>
                  </label>
                  <Preview
                    preview={preview}
                    imageSrc={imageSrc}
                    onClick={onClick}
                  />
                </div>
                {formik.touched.filePath && formik.errors.filePath ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.filePath}
                    </div>
                  </div>
                ) : null}
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => onHide(false)}>
            Close
          </Button>
          <Button type="submit">Create</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}